<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'post',

    metaInfo: { title: 'Soutien' },

    extends: View,

    mixins: [
      LoadSections([
        'hero-alt',
        'post',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'post',
      },
    },
  }
</script>
